<template>
  <div class="container">
    <div class="content" v-html="state.contentHtmlText">
    </div>
  </div>
</template>

<script>
import { defineComponent, nextTick, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import { querySyActivitySelectByIdDetail } from "@/api/user";

export default defineComponent({
  name: "HtmlParsing",

  components: {
  },

  setup() {
    const route = useRoute();

    const state = reactive({
      contentHtmlText: null,
      contentHtmlId: null
    });

    onMounted(() => {
      if (route?.query?.id) {
        state.contentHtmlId = route?.query?.id;
        initData()
      }

      
      
      
    });

    const initData = async () => {
      try {
        const result = await querySyActivitySelectByIdDetail({
          id: state.contentHtmlId
        })
        if(result.code == '00') {
          // 处理内容并设置视频属性
          state.contentHtmlText = processVideoContent(result.data.content)
          
          // 在DOM更新后处理视频
          nextTick(() => {
            // 获取所有视频元素
            const videos = document.querySelectorAll('video')
            videos.forEach(video => {
              // 监听视频加载完成事件
              video.addEventListener('loadeddata', () => {
                // 确保视频加载完成后暂停在第一帧
                video.currentTime = 0.1
                video.pause()
                
                // 自动触发一次点击事件
                const wrapper = video.closest('.video-wrapper')
                if (wrapper) {
                  const clickEvent = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                  })
                  wrapper.dispatchEvent(clickEvent)
                }
              })

              // 监听视频播放事件
              video.addEventListener('play', () => {
                // 显示控制条
                video.controls = true
              })

              // 处理视频错误
              video.addEventListener('error', (e) => {
                console.error('Video error:', e)
              })
            })
          })
        }
      } catch (error) {
        console.error('Error fetching content:', error)
      }
    }

    const processVideoContent = (content) => {
      // Create a temporary div to parse the HTML content
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = content

      // Find all video elements
      const videos = tempDiv.getElementsByTagName('video')
      
      // Process each video
      Array.from(videos).forEach((video, index) => {
        // 创建包装容器
        const wrapper = document.createElement('div')
        wrapper.className = 'video-wrapper'
        
        // 将视频从原位置移动到包装容器中
        video.parentNode.insertBefore(wrapper, video)
        wrapper.appendChild(video)
        
        // 添加播放图标
        const playIcon = document.createElement('div')
        playIcon.className = 'video-play-icon'
        wrapper.appendChild(playIcon)

        // 添加视频属性
        video.setAttribute('preload', 'metadata')
        video.setAttribute('muted', '')
        video.setAttribute('playsinline', '')
        video.setAttribute('webkit-playsinline', '')
        video.setAttribute('x5-playsinline', '')
        video.setAttribute('x5-video-player-type', 'h5')
        video.setAttribute('x5-video-player-fullscreen', 'false')
        video.setAttribute('playsInline', '')
        video.setAttribute('poster', video.src + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast')
        video.removeAttribute('controls')
        video.removeAttribute('autoplay')
        
        // 更新点击事件为包装容器的点击事件
        wrapper.setAttribute('onclick', `
          const video = this.querySelector('video');
          const icon = this.querySelector('.video-play-icon');
          video.controls = true;
          
          // 先尝试播放静音视频
          video.muted = true;
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              // 播放成功后取消静音
              video.muted = false;
            }).catch(error => {
              console.error('Play failed:', error);
            });
          }
          
          icon.style.display = 'none';
        `)
      })

      return tempDiv.innerHTML
    }

    return {
      state,
    };
  },
});
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
  height: 100%;
  background-color: #e9f1f8;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 12px;
  overflow-y: scroll;
  max-width: 100%;
  overflow-x: hidden;
}

:deep(img) {
  max-width: 100% !important;
  height: auto;
}

:deep(.video-thumbnail-container) {
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

:deep(.video-thumbnail) {
  transition: transform 0.2s ease;
}

:deep(.video-thumbnail:hover) {
  transform: scale(1.02);
}

:deep(.video-wrapper) {
  position: relative;
  width: 100%;
  display: block;
  cursor: pointer;
  max-width: 100vw;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
  margin: 10px 0;
}

:deep(.video-play-icon) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: all 0.3s ease;
}

:deep(.video-play-icon:hover) {
  background-color: rgba(0, 0, 0, 0.8);
  transform: translate(-50%, -50%) scale(1.1);
}

:deep(.video-play-icon::after) {
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 12px 0 12px 20px;
  border-color: transparent transparent transparent #ffffff;
  margin-left: 4px;
}

:deep(video) {
  max-width: 100% !important;
  height: auto;
  border-radius: 4px;
  background-color: transparent;
  object-fit: cover;
  -webkit-tap-highlight-color: transparent;
  display: block;
  min-height: 200px;
}

:deep(.video-wrapper:hover) {
  .video-play-icon {
    background-color: rgba(0, 0, 0, 0.8);
  }
}

/* 移动端样式优化 */
@media (max-width: 768px) {
  :deep(.video-play-icon) {
    width: 48px;
    height: 48px;
  }

  :deep(.video-play-icon::after) {
    border-width: 10px 0 10px 16px;
  }
}
</style>
